//import { DispatchSearchType } from "../enums/dispatchSearchType";

import { BaseBus } from "./BaseBus";

export class DispatchBoardSearch extends BaseBus {
    constructor(data: DispatchBoardSearch) {
        super(data);
        if (data) {
            this.onCallRegions = data.onCallRegions;
            this.divisions = data.divisions;
            this.states = data.states;
            this.acctMgrs = data.acctMgrs;
            this.customers = data.customers;
            this.acctClasses = data.acctClasses;

        }
        }

    active: boolean = true;
    customSearch: boolean = false;
    boardViewId: string;
    divisionId: any;
    divisions: string[] = [];
    onCallRegions: string[] = [];
    srvConst: string;
    states: string[];
    dispatchViewId: any;
    acctMgrId: any;
    acctMgrs: string[];
    customers: string[];
    userId: any;
    statusId: any;
    acctClasses: string[];
    boardStatuses: any;
    boardPersons: any;
    assignedDispatches: any;
    startDt: Date;
    endDt: Date;

    companyId: any;
    isGlobal: boolean;
    isActive: boolean;
    isDefault: boolean;
    dispatchViewName: string;
    dispatchViewDesc: string;
    excludeContracts: boolean;
    sort: string;
}
